export default {
    data() {
        return {
            code: '',
            payType: '',//支付方式
            commodityList: [],
            totalprices: 0,
            detailsBox: true,
            paycenterXinxiisapprove: false,
            toPayBtn: true,
        }
    },
    methods: {
        //显示商品详情
        isDetailsBox: function () {
            this.detailsBox = !this.detailsBox;
        },
        //嵌入支付宝页面
        isPay: function (data, id) {
            let end = data.indexOf('{"status"');
            let block = data.substring(0, end);
            let div = document.createElement('div');
            div.innerHTML = block;
            document.querySelector('#paycenter').appendChild(div);
            document.forms['alipaysubmit'].submit();
        },
        //支付中心获取相应数据
        getMyorder: function () {
            this.code = this.$route.query.code;
            let arr = JSON.parse(this.$route.query.commodityList);
            for (let id of arr) {
                this.$post('products/get', { id: id }).then(res => {
                    res.data.result.id = id;
                    this.commodityList.push(res.data.result);
                    this.totalprices += Number.parseFloat(res.data.result.price);
                });
            }
        },
        //选择不同支付方式
        goOrderDetails: function () {
            let order_id = this.$route.query.order_id;
            if (this.payType === 'alipay') {
                this.$post('orders/alipay', { id: order_id, token: this.$store.state.id }).then(res => {
                    this.isPay(res.data, order_id);
                })
            } else if (this.payType === 'wxpay') {
                this.$post('orders/wxpay', { id: order_id, token: this.$store.state.id }).then(res => {
                    this.$router.push({
                        name: 'wechatpay',
                        params: {
                            wechatpay: res.data.result,
                            order_id: order_id
                        }
                    });
                })
            } else if (this.payType === 'balancepay') {
                //获取账户余额
                this.$post('users/profile', { token: this.$store.state.id }).then(res => {
                    let balance = 0;
                    if (res.data.status === 'success') {
                        let balance1 = res.data.result.balance;
                        //计算支付后的余额
                        balance = balance1 - this.totalprices;
                        if (balance < 0) {
                            this.$message({
                                showClose: true,
                                message: '余额不足',
                                type: 'error'
                            });
                        }
                        else {
                            //更新账户余额
                            this.updataBalance(balance);

                            // 向余额日志表中插入数据
                            this.createLog(balance, this.totalprices)
                        }
                    }
                })
            } else {
                let model = document.querySelector('#modal-pay');
                UIkit.modal(model).show();
            }
        },
        //更新账户余额
        updataBalance(balance) {
            // // console.log(balance);
            this.$post('users/balance_token', { balance: balance, id: this.$store.state.id, token: this.$store.state.id }).then(res => {
                if (res.data.status === 'success') {
                    // 更改订单状态
                    this.updataOrder();
                }
                else {
                    this.$message({
                        showClose: true,
                        message: '支付失败',
                        type: 'error'
                    });
                }
            })

        },
        // 更改订单状态
        updataOrder() {
            let date = this.getPayDate()
            // console.log(date)

            this.$post('orders/edit_state', { pay_type: 5, state: 2, id: this.$route.query.order_id, token: this.$store.state.id, pay_date: date }).then(res => {
                // // console.log(res.data.status);
                if (res.data.status === 'success') {
                    // // console.log(this.$route.query.order_id);
                    this.$router.push({
                        path: '/myorderdetails',
                        query: {
                            order_id: this.$route.query.order_id
                        }
                    });
                }
                else {
                    this.$message({
                        showClose: true,
                        message: '订单生成失败',
                        type: 'error'
                    });
                }
            })
        },
        //选择支付方式
        changeBorder(who) {
            switch (who) {

                case 'zfb':
                    this.payType = 'alipay';
                    this.$refs.zfb.style.border = "1px solid #21a557";
                    this.$refs.wx.style.border = "1px solid #cccccc";
                    this.$refs.payxinxi.style.border = "1px solid #cccccc";
                    this.$refs.balance.style.border = "1px solid #cccccc";
                    this.toPayBtn = true;
                    this.$refs.zfbSjx.style.backgroundPosition = "0 -161px";
                    this.$refs.wxSjx.style.backgroundPosition = "0 -187px";
                    this.$refs.payxinxiSjx.style.backgroundPosition = "0 -187px";
                    this.$refs.balanceSjx.style.backgroundPosition = "0 -187px";
                    this.paycenterXinxiisapprove = false;
                    break;

                case 'balance':
                    this.payType = 'balancepay';
                    this.$refs.balance.style.border = "1px solid #21a557";
                    this.$refs.wx.style.border = "1px solid #cccccc";
                    this.$refs.zfb.style.border = "1px solid #cccccc";
                    this.$refs.payxinxi.style.border = "1px solid #cccccc";
                    this.toPayBtn = true;
                    this.$refs.balanceSjx.style.backgroundPosition = "0 -161px";
                    this.$refs.wxSjx.style.backgroundPosition = "0 -187px";
                    this.$refs.zfbSjx.style.backgroundPosition = "0 -187px";
                    this.$refs.payxinxiSjx.style.backgroundPosition = "0 -187px";
                    this.paycenterXinxiisapprove = false;
                    break;

                case 'wx':
                    this.payType = 'wxpay';
                    this.toPayBtn = true;
                    this.$refs.zfb.style.border = "1px solid #cccccc"
                    this.$refs.wx.style.border = "1px solid #21a557"
                    this.$refs.payxinxi.style.border = "1px solid #cccccc"
                    this.$refs.balance.style.border = "1px solid #cccccc";
                    this.$refs.zfbSjx.style.backgroundPosition = "0 -187px"
                    this.$refs.wxSjx.style.backgroundPosition = "0 -161px"
                    this.$refs.payxinxiSjx.style.backgroundPosition = "0 -187px"
                    this.$refs.balanceSjx.style.backgroundPosition = "0 -187px";
                    this.paycenterXinxiisapprove = false;
                    break;

                case 'payxinxi':
                    this.toPayBtn = false;
                    this.$refs.zfb.style.border = "1px solid #cccccc"
                    this.$refs.wx.style.border = "1px solid #cccccc"
                    this.$refs.payxinxi.style.border = "1px solid #21a557"
                    this.$refs.balance.style.border = "1px solid #cccccc";
                    this.$refs.zfbSjx.style.backgroundPosition = "0 -187px"
                    this.$refs.wxSjx.style.backgroundPosition = "0 -187px"
                    this.$refs.balanceSjx.style.backgroundPosition = "0 -187px";
                    this.$refs.payxinxiSjx.style.backgroundPosition = "0 -161px"
                    this.paycenterXinxiisapprove = true;
                    break;
            }
        },
        //跳转商品页面
        commodityDetails: function (id) {
            this.$router.push({
                path: '/classdetails',
                query: {
                    id: id
                }
            });

        },

        // 插入用户余额更改记录到用户余额日志表
        /**
         * 
         * @param {*} balance 购买完成后的用户余额
         * @param {*} consumption 本次支付消费金额
         */
        createLog(balance, consumption) {
            // console.log('balance', balance)
            // console.log('consumption', consumption)
            this.$post('user_log/create_by_token', {
                count: consumption,
                token: this.$store.state.id,
                content: '支出' + consumption + '元',
                balance: balance,
                shop_id: this.$store.state.store.id
            })
        },

        // 获取当前的支付时间
        getPayDate() {
            let date = new Date()
            let year = date.getFullYear()
            let month = this.addZero(date.getMonth() + 1)
            let day = this.addZero(date.getDate())
            let hour = this.addZero(date.getHours())
            let minute = this.addZero(date.getMinutes())
            let second = this.addZero(date.getSeconds())
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second 
        },

        // 补0
        addZero (number) {
            if (number < 10) {
                return '0' + number
            } else {
                return number
            }
        } 

    },
    created() {
        this.getMyorder();
        // // console.log(this.$route.query);
        // let order_id=this.$route.query.order_id;
        // this.lastAddress='?id='+order_id+'&token?';
    },
    mounted() {
        // this.$refs.changeBorder.style['border']='1px solid #21a557';
        document.title = '支付中心';
    },
}